import React, { useEffect, useState } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { SignInButton } from '../components/SignInButton';
import { SignOutButton } from '../components/SignOutButton';
import img from '../assets/Nigerian-Coat-of-Arms.png';
import '../styles/landing.css'; 
import backgroundimage from '../assets/Image.jpg';
import { toast } from "react-toastify";

const Landing = () => {
    const isAuthenticated = useIsAuthenticated();
    
    useEffect(() => {
        const error = sessionStorage.getItem("Error");
    
        if (error) {
            if (!window.errorDisplayed) { 
                toast.error(error);
                window.errorDisplayed = true;
            }
            sessionStorage.removeItem("Error");
        }
    }, []);
    

    return (
        <div className="landingPage">
            {/* Header */}
            <div className="header">
                <img src={img} alt="Crest Logo" className="headerLogo" />
                <div className="headerTitle">
                    <h1 className="title">NIGERIAN CASE MANAGEMENT SYSTEM.</h1>
                    <h2 className="subtitle">e-AFFIDAVIT</h2>
                </div>
            </div>

            {/* Main Content */}
            <div className="main">
                <div className="content">
                    <p className="text-content">
                        Welcome to the Nigeria Case Management System (NCMS) Electronic Affidavit (e-affidavit) Platform.
                    </p>

                    <div className="noticeBox">
                        <p>
                            NB: This service is only available to lawyers and court staff with LegalMail 
                            (yourname@nigerianbar.ng or yourname@courts.gov.ng). You can sign in with your legal mail.
                        </p>
                        {/* <SignInButton /> */}
                        {isAuthenticated ? <SignOutButton /> : <SignInButton />  }
                    </div>
                </div>

                {/* Side Image */}
                <div className="sideImage">
                        <img src={backgroundimage} className="circleBackground"></img>
                </div>
            </div>
            {/* Footer */}
            <div className='footer'>
                    <p>
                    Copyrights © {new Date().getFullYear()} National Judicial Council. All Rights Reserved.
                    </p>
                  
            </div>
        </div>
    );
};

export default Landing;